//  存放静态公用数据

// 语言
const Language = [
  //语言
  // 中文
  {
    value: "zh",
    label: "中文",
    number: 0,
  },
  // 英语
  {
    value: "en",
    label: "English",
    number: 1,
  },
  // 越南语
  // {
  //   value: "vi",
  //   label: "Tiếng Việt",
  //   number: 5,
  // },
  // // 马来语
  // {
  //   value: "ms",
  //   label: "Melayu",
  //   number: 4,
  // },
  // // 缅甸语
  // {
  //   value: "my",
  //   label: "မြန်မာစာ",
  //   number: 7,
  // },
  // 泰语
  // {
  //   value: 'th',
  //   label: 'ภาษาไทย'
  // },
];

const AnnouncementType = [
  //公告类型
  {
    value: "0",
    CnName: "通用",
    EnName: "general",
    langLabel: "general",
  },
  {
    value: "1",
    CnName: "全系统",
    EnName: "system-wide",
    langLabel: "system_wide",
  },
  {
    value: "2",
    CnName: "管理端",
    EnName: "managementSide",
    langLabel: "Management",
  },
  {
    value: "3",
    CnName: "客户端",
    EnName: "clientSide",
    langLabel: "clientSide",
  },
];

const Platform = [
  //平台
  {
    value: 11,
    CnName: "Lazada",
    EnName: "Lazada",
    langLabel: "Lazada",
  },
  {
    value: 13,
    CnName: "Shopee",
    EnName: "Shopee",
    langLabel: "Shopee",
  },
  {
    value: 15,
    CnName: "TikTok",
    EnName: "TikTok",
    langLabel: "TikTok",
  },
  {
    value: 16,
    CnName: "Lazada托管",
    EnName: "LazadaTrusteeship",
    langLabel: "LazadaTrusteeship",
  },
  {
    value: 19,
    CnName: "线下店铺",
    EnName: "Offline stores",
    langLabel: "Offline_stores",
  },
  {
    value: 20,
    CnName: "Temu",
    EnName: "Temu",
    langLabel: "Temu",
  },
  {
    value: 9999,
    CnName: "Other",
    EnName: "Other",
    langLabel: "Other",
  },
];
const addTemuPlatform = [
  //平台
  {
    value: 11,
    CnName: "Lazada",
    EnName: "Lazada",
  },
  {
    value: 13,
    CnName: "Shopee",
    EnName: "Shopee",
  },
  {
    value: 15,
    CnName: "TikTok",
    EnName: "TikTok",
  },
  {
    value: 16,
    CnName: "Lazada托管",
    EnName: "LazadaTrusteeship",
  },
  {
    value: 20,
    CnName: "Temu",
    EnName: "Temu",
  },
  {
    value: 19,
    CnName: "线下店铺",
    EnName: "Offline stores",
  },
  {
    value: 9999,
    CnName: "Other",
    EnName: "Other",
  },
];
const LogisticsStatus = [
  //物流状态
  {
    value: 0,
    CnName: "未获取",
    EnName: "Not acquired",
    langLabel: "Not_Acquired",
  },
  {
    value: 1,
    CnName: "未上网",
    EnName: "Not online",
    langLabel: "Not_Online",
  },
  {
    value: 2,
    CnName: "运输中",
    EnName: "in transit",
    langLabel: "in_transit",
  },
  {
    value: 9999,
    CnName: "已交付",
    EnName: "delivered",
    langLabel: "Delivered",
  },
];

const OrderStatus = [
  //订单状态
  {
    value: "1",
    CnName: "待审核",
    EnName: "To be reviewed",
  },
  {
    value: "2",
    CnName: "待发货",
    EnName: "Goods waiting to be sent",
  },
  {
    value: "3",
    CnName: "发货中",
    EnName: "In transit",
  },
  {
    value: "4",
    CnName: "已发货",
    EnName: "shipped",
  },
  {
    value: "5",
    CnName: "已作废",
    EnName: "have been voided",
  },
  {
    value: "6",
    CnName: "配货中",
    EnName: "Being distributed",
  },
  {
    value: "8",
    CnName: "取消",
    EnName: "Cancel",
  },
];

const FirstLegOrderStatus = [
  //头程单阶段
  {
    value: "9999",
    CnName: "全部",
    EnName: "All",
    class: "OrderStateInfo",
  },
  {
    value: "0",
    CnName: "草稿",
    EnName: "draft",
    class: "OrderStateInfo",
  },
  {
    value: "1",
    CnName: "待审核",
    EnName: "To_be_reviewed",
    class: "OrderStatePrimary",
  },
  {
    value: "2",
    CnName: "已审核",
    EnName: "audited",
    class: "OrderStatePrimary",
  },
  {
    value: "5",
    CnName: "中转仓收货",
    EnName: "TWR",
    class: "OrderStatePrimary",
  },
  {
    value: "6",
    CnName: "运输中",
    EnName: "in transit",
    class: "OrderStatePrimary",
  },
  {
    value: "7",
    CnName: "尾程已收货",
    EnName: "The Last Leg Received",
    class: "OrderStateSuccess",
  },
  {
    value: "3",
    CnName: "已完成",
    EnName: "completed",
    class: "OrderStateSuccess",
  },
  {
    value: "4",
    CnName: "已作废",
    EnName: "have been voided",
    class: "OrderStateWarning",
  },
  {
    value: "100",
    CnName: "异常",
    EnName: "abnormal",
    class: "OrderStateWarning",
  },
];

const ManagementFirstLegOrderStatus = [
  //管理端头程单阶段
  {
    value: "9999",
    CnName: "全部",
    EnName: "All",
    langLabel: "All",
  },
  {
    value: "1",
    CnName: "待审核",
    EnName: "To_be_reviewed",
    langLabel: "To_be_reviewed",
  },
  {
    value: "2",
    CnName: "已审核",
    EnName: "audited",
    langLabel: "audited",
  },
  {
    value: "5",
    CnName: "中转仓收货",
    EnName: "TWR",
    langLabel: "Transfer_Warehouse_Receipt",
  },
  {
    value: "6",
    CnName: "运输中",
    EnName: "in transit",
    langLabel: "in_transit",
  },
  {
    value: "7",
    CnName: "尾程已收货",
    EnName: "The Last Leg Received",
    langLabel: "The_Last_Leg_Received",
  },
  {
    value: "3",
    CnName: "已完成",
    EnName: "completed",
    langLabel: "completed",
  },
  {
    value: "100",
    CnName: "异常",
    EnName: "abnormal",
    langLabel: "abnormal",
  },
];

const FirstBillingStage = [
  //头程账单阶段
  {
    value: "0",
    CnName: "未生成",
    EnName: "not generate",
    class: "OrderStateInfo",
  },
  {
    value: "1",
    CnName: "待处理",
    EnName: "pending",
    class: "OrderStatePrimary",
  },
  {
    value: "2",
    CnName: "待付款",
    EnName: "obligation",
    class: "OrderStateWarning",
  },
  {
    value: "3",
    CnName: "财务核实",
    EnName: "Financial verification",
    class: "OrderStateWarning",
  },
  {
    value: "4",
    CnName: "核实收款",
    EnName: "Verify collection",
    class: "OrderStateWarning",
  },
  {
    value: "5",
    CnName: "完成",
    EnName: "accomplish",
    class: "OrderStateSuccess",
  },
];

const ManagementFirstBillingStage = [
  //管理端头程账单阶段
  {
    value: "0",
    CnName: "未生成",
    EnName: "not generate",
    class: "OrderStateInfo",
    langLabel: "Not_Generated",
  },
  {
    value: "1",
    CnName: "待处理",
    EnName: "pending",
    class: "OrderStatePrimary",
    langLabel: "Pending_Processing",
  },
  {
    value: "2",
    CnName: "待收款",
    EnName: "obligation",
    class: "OrderStatePrimary",
    langLabel: "Pending_Collection",
  },
  {
    value: "3",
    CnName: "财务核实",
    EnName: "Financial verification",
    class: "OrderStateWarning",
    langLabel: "Financial_Verification",
  },
  {
    value: "4",
    CnName: "核实收款",
    EnName: "Verify collection",
    class: "OrderStateWarning",
    langLabel: "Collection_Confirmed",
  },
  {
    value: "5",
    CnName: "完成",
    EnName: "accomplish",
    class: "OrderStateSuccess",
    langLabel: "finish",
  },
];

const OrderTypes = [
  //头程订单类型
  {
    value: 1,
    CnName: "头程单",
    EnName: "FirstLegOrder",
  },
  {
    value: 2,
    CnName: "入库单",
    EnName: "InventoryOrder",
  },
  // {
  //   value: 4,
  //   CnName: '三方仓入库单',
  //   EnName: 'ThirdPartyInventoryOrder'
  // },
  {
    value: 3,
    CnName: "头程单+入库单",
    EnName: "FirstLegOrder+InventoryOrder",
  },
  // {
  //   value: 5,
  //   CnName: '头程单+三方仓入库单',
  //   EnName: 'FirstLegOrder+ThirdPartyInventoryOrder'
  // }
];

const StatusOfStorageReceipt = [
  //入库单阶段
  {
    value: "9999",
    CnName: "全部",
    EnName: "All",
    class: "OrderStateInfo",
    langLabel: "all",
  },
  {
    value: "0",
    CnName: "草稿",
    EnName: "draft",
    class: "OrderStateInfo",
    langLabel: "draft",
  },
  {
    value: "1",
    CnName: "待审核",
    EnName: "To_be_reviewed",
    class: "OrderStatePrimary",
    langLabel: "To_be_reviewed",
  },
  {
    value: "8",
    CnName: "已审核",
    EnName: "audited",
    class: "OrderStateSuccess",
    langLabel: "audited",
  },
  {
    value: "9",
    CnName: "中转仓收货",
    EnName: "TWR",
    class: "OrderStateSuccess",
    langLabel: "Transfer_Warehouse_Receipt",
  },
  {
    value: "10",
    CnName: "运输中",
    EnName: "in transit",
    class: "OrderStatePrimary",
    langLabel: "in_transit",
  },
  {
    value: "11",
    CnName: "尾程收货中",
    EnName: "Tail stroke Receiving the goods",
    class: "OrderStatePrimary",
    langLabel: "Last_Mile_Receiving_In_Progress",
  },
  {
    value: "2",
    CnName: "尾程已收货",
    EnName: "The Last Leg Received",
    class: "OrderStateSuccess",
    langLabel: "The_Last_Leg_Received",
  },
  {
    value: "12",
    CnName: "质检中",
    EnName: "In quality inspection",
    class: "OrderStatePrimary",
    langLabel: "Quality_Inspection_In_Progress",
  },
  {
    value: "3",
    CnName: "已质检",
    EnName: "inspected",
    class: "OrderStateSuccess",
    langLabel: "inspected",
  },
  {
    value: "13",
    CnName: "上架中",
    EnName: "listing",
    class: "OrderStatePrimary",
    langLabel: "Shelving_in_progress",
  },
  {
    value: "4",
    CnName: "已上架",
    EnName: "inspected",
    class: "OrderStateSuccess",
    langLabel: "Already_listed",
  },
  {
    value: "5",
    CnName: "已作废",
    EnName: "have been voided",
    class: "OrderStateWarning",
    langLabel: "have_been_voided",
  },
  {
    value: "14",
    CnName: "异常",
    EnName: "abnormal",
    class: "OrderStateDanger",
    langLabel: "abnormal",
  },
];

const ManagementStatusOfStorageReceipt = [
  //管理端入库单阶段
  {
    value: "9999",
    CnName: "全部",
    EnName: "All",
    class: "OrderStateInfo",
    langLabel: "All",
  },
  {
    value: "1",
    CnName: "待审核",
    EnName: "To_be_reviewed",
    class: "OrderStatePrimary",
    langLabel: "To_be_reviewed",
  },
  {
    value: "8",
    CnName: "已审核",
    EnName: "audited",
    class: "OrderStateSuccess",
    langLabel: "audited",
  },
  {
    value: "9",
    CnName: "中转仓收货",
    EnName: "TWR",
    class: "OrderStateSuccess",
    langLabel: "Transfer_Warehouse_Receipt",
  },
  {
    value: "10",
    CnName: "运输中",
    EnName: "in transit",
    class: "OrderStatePrimary",
    langLabel: "in_transit",
  },
  {
    value: "11",
    CnName: "尾程收货中",
    EnName: "Tail stroke Receiving the goods",
    class: "OrderStatePrimary",
    langLabel: "Last_Mile_Receiving_In_Progress",
  },
  {
    value: "2",
    CnName: "尾程已收货",
    EnName: "The Last Leg Received",
    class: "OrderStateSuccess",
    langLabel: "The_Last_Leg_Received",
  },
  {
    value: "12",
    CnName: "质检中",
    EnName: "In quality inspection",
    class: "OrderStatePrimary",
    langLabel: "Quality_Inspection_In_Progress",
  },
  {
    value: "3",
    CnName: "已质检",
    EnName: "inspected",
    class: "OrderStateSuccess",
    langLabel: "inspected",
  },
  {
    value: "13",
    CnName: "上架中",
    EnName: "listing",
    class: "OrderStatePrimary",
    langLabel: "Shelving_In_Progress",
  },
  {
    value: "4",
    CnName: "已上架",
    EnName: "inspected",
    class: "OrderStateSuccess",
    langLabel: "Already_listed",
  },
  {
    value: "5",
    CnName: "已作废",
    EnName: "have been voided",
    class: "OrderStateWarning",
    langLabel: "have_been_voided",
  },
  {
    value: "14",
    CnName: "异常",
    EnName: "abnormal",
    class: "OrderStateDanger",
    langLabel: "abnormal",
  },
];

const DeliveryType = [
  //交货方式
  {
    value: true,
    CnName: "自送到仓",
    EnName: "Self-delivery warehouse",
  },
  {
    value: false,
    CnName: "上门揽收",
    EnName: "Door-to-door collection",
  },
];

const ChannelType = [
  //渠道类型（暂用）
  {
    value: 103,
    CnName: "海运",
    EnName: "Sea Shipping",
  },
  {
    value: 102,
    CnName: "空运",
    EnName: "Air Shipping",
  },
  {
    value: 108,
    CnName: "海运-快船",
    EnName: "Sea Shipping Fast ship",
  },
  {
    value: 116,
    CnName: "陆运",
    EnName: "Land transport",
  },
];

const InitiateMode = [
  //启用状态
  {
    value: 0,
    CnName: "禁用",
    EnName: "forbidden",
    langLabel: "forbidden",
  },
  {
    value: 1,
    CnName: "启用",
    EnName: "Enabled",
    langLabel: "Enabled",
  },
];

const AlarmThresholdStatus = [
  //预警阈值状态
  {
    value: 0,
    CnName: "异常",
    EnName: "abnormal",
  },
  {
    value: 1,
    CnName: "正常",
    EnName: "normal",
  },
];

const PortType = [
  //端口类型
  {
    value: 1,
    cnName: "客户端",
    enName: "clientSide",
  },
  {
    value: 2,
    cnName: "管理端",
    enName: "managementSide",
  },
];

const BillingMethod = [
  // 计费方式
  {
    value: "1",
    cnName: "立方",
    enName: "cube",
    langLabel: "cube",
  },
  {
    value: "2",
    cnName: "三边",
    enName: "three sides",
    langLabel: "Three_sides",
  },
  {
    value: "3",
    cnName: "重量",
    enName: "weight",
    langLabel: "weight",
  },
  {
    value: "4",
    cnName: "先三边后重量",
    enName: "Three sides before weight",
    langLabel: "Three_sides_before_weight",
  },
  {
    value: "5",
    cnName: "先重量后三边",
    enName: "First weight then three sides",
    langLabel: "First_weight_then_three_sides",
  },
  {
    value: "6",
    cnName: "先立方后重量",
    enName: "First cubic then weight",
    langLabel: "First_cubic_then_weight",
  },
  {
    value: "7",
    cnName: "先重量后立方",
    enName: "First weight then cube",
    langLabel: "First_weight_then_cube",
  },
  {
    value: "8",
    cnName: "先立方后三边",
    enName: "First cube and then three sides",
    langLabel: "First_cube_and_then_three_sides",
  },
  {
    value: "9",
    cnName: "先三边后立方",
    enName: "Three sides before the cube",
    langLabel: "Three_sides_before_the_cube",
  },
];

const FirstVesselBillingMethod = [
  //头程计费方式
  {
    value: 1,
    cnName: "重量",
    enName: "weight",
  },
  {
    value: 2,
    cnName: "立方",
    enName: "cube",
  },
  {
    value: 3,
    cnName: "体积重",
    enName: "volume weight",
  },
];

const PrecedenceBillingMethod = [
  //优先计费方式
  {
    value: 1,
    cnName: "立方",
    enName: "cube",
  },
  {
    value: 2,
    cnName: "三边",
    enName: "three sides",
  },
  {
    value: 3,
    cnName: "重量",
    enName: "weight",
  },
  {
    value: 4,
    cnName: "先三边后重量",
    enName: "Three sides before weight",
  },
  {
    value: 5,
    cnName: "先重量后三边",
    enName: "First weight then three sides",
  },
  {
    value: 6,
    cnName: "先立方后重量",
    enName: "First cubic then weight",
  },
  {
    value: 7,
    cnName: "先重量后立方",
    enName: "First weight then cube",
  },
  {
    value: 8,
    cnName: "先立方后三边",
    enName: "First cube and then three sides",
  },
  {
    value: 9,
    cnName: "先三边后立方",
    enName: "Three sides before the cube",
  },
  {
    value: 10,
    cnName: "金额",
    enName: "money",
  },
];
// 今日达状态
export const TodayDeliveryStatus = [
  {
    value: "1",
    CnName: "今日达",
    EnName: "Today_delivery",
    class: "OrderStateSuccess",
    langLabel: "Today_delivery",
  },
  {
    value: "2",
    CnName: "次日达",
    EnName: "Nextday_delivery",
    class: "OrderStatePrimary",
    langLabel: "Nextday_delivery",
  },
];

const OrderDisposeStatus = [
  //仓储订单列表状态
  {
    value: "0",
    CnName: "全部",
    EnName: "All",
    class: "OrderStateInfo",
    langLabel: "All",
  },
  {
    value: "12",
    CnName: "待处理",
    EnName: "Pending",
    class: "OrderStatePrimary",
    langLabel: "Pending",
  },
  {
    value: "1",
    CnName: "待审核",
    EnName: "To be reviewed",
    class: "OrderStatePrimary",
    langLabel: "To_be_reviewed",
  },
  {
    value: "10",
    CnName: "运单号获取中",
    EnName: "The tracking number is being obtained",
    class: "OrderStatePrimary",
    langLabel: "Obtaining_tracking_number",
  },
  {
    value: "2",
    CnName: "待发货",
    EnName: "drop shipping",
    class: "OrderStatePrimary",
    langLabel: "Pending_shipment",
  },
  {
    value: "6",
    CnName: "配货中",
    EnName: "Being distributed",
    class: "OrderStatePrimary",
    langLabel: "Being_distributed",
  },
  {
    value: "3",
    CnName: "发货中",
    EnName: "In transit",
    class: "OrderStatePrimary",
    langLabel: "In_transit",
  },
  {
    value: "4",
    CnName: "已发货",
    EnName: "shipped",
    class: "OrderStateSuccess",
    langLabel: "shipped",
  },
  {
    value: "11",
    CnName: "已交运",
    EnName: "shipped",
    class: "OrderStateSuccess",
    langLabel: "delivered",
  },
  {
    value: "5",
    CnName: "已作废",
    EnName: "have_been_voided",
    class: "OrderStateWarning",
    langLabel: "have_been_voided",
  },
  {
    value: "8",
    CnName: "取消",
    EnName: "Cancel",
    class: "OrderStateDanger",
    langLabel: "cancel",
  },
  // 已关闭
  {
    value: "13",
    langLabel: "Closed",
    class: "OrderStateDanger",
  },
];

const ManagementSideOrderDisposeStatus = [
  //管理端仓储订单列表状态
  {
    value: "0",
    CnName: "全部",
    EnName: "All",
    class: "OrderStateInfo",
  },
  {
    value: "2",
    CnName: "待发货",
    EnName: "drop shipping",
    class: "OrderStatePrimary",
  },
  {
    value: "6",
    CnName: "配货中",
    EnName: "Being distributed",
    class: "OrderStatePrimary",
  },
  {
    value: "3",
    CnName: "发货中",
    EnName: "In transit",
    class: "OrderStatePrimary",
  },
  {
    value: "4",
    CnName: "已发货",
    EnName: "shipped",
    class: "OrderStateSuccess",
  },
  {
    value: "11",
    CnName: "已交运",
    EnName: "shipped",
    class: "OrderStateSuccess",
  },
  {
    value: "5",
    CnName: "已作废",
    EnName: "have_been_voided",
    class: "OrderStateWarning",
  },
  {
    value: "8",
    CnName: "取消",
    EnName: "Cancel",
    class: "OrderStateDanger",
  },
  // 已关闭
  {
    value: "13",
    langLabel: "Closed",
    class: "OrderStateDanger",
  },
];
// 取消订单状态

const CancellationOrderStatus = [
  {
    value: "16",
    CnName: "取消申请",
    EnName: "CancelOrder",
    class: "OrderStateDanger",
  },
  {
    value: "8",
    CnName: "取消",
    EnName: "Cancel",
    class: "OrderStateDanger",
  },
];
const ReturnPhase = [
  //退货阶段
  {
    value: 0,
    cnName: "待收货",
    enName: "wait for receiving",
    langLabel: "Pending_receipt",
  },
  {
    value: 1,
    cnName: "待审核",
    enName: "To be reviewed",
    langLabel: "To_be_reviewed",
  },
  {
    value: 10,
    cnName: "待上架",
    enName: "To be listed",
    langLabel: "To_be_put_on_the_shelf",
  },
  {
    value: 11,
    cnName: "上架中",
    enName: "listing",
    langLabel: "Shelving_in_progress",
  },
  {
    value: 2,
    cnName: "已上架",
    enName: "Already listed",
    langLabel: "Already_listed",
  },
  {
    value: 3,
    cnName: "驳回",
    enName: "turn down",
    langLabel: "Reject",
  },
  {
    value: 4,
    cnName: "废弃",
    enName: "abandon",
    langLabel: "Abandon",
  },
  {
    value: 8,
    cnName: "认领区",
    enName: "Claim area",
    langLabel: "Claim_area",
  },
  {
    value: 9,
    cnName: "销毁",
    enName: "have been voided",
    langLabel: "Destroyed",
  },
  {
    value: 12,
    cnName: "转运",
    enName: "transfer",
    langLabel: "Transferred",
  },
];

const ReturnOrderTypes = [
  //退货订单类型
  {
    value: 2,
    cnName: "原单",
    enName: "Original order",
  },
  {
    value: 3,
    cnName: "非原单",
    enName: "Nonoriginal order",
  },
  {
    value: 21,
    cnName: "三方仓",
    enName: "Three-way position",
  },
];

const StockUnitType = [
  //库位类型
  {
    value: 0,
    cnName: "拣货库位",
    enName: "",
  },
  {
    value: 1,
    cnName: "备货库位",
    enName: "Stock storage location",
  },
  {
    value: 2,
    cnName: "虚拟库位",
    enName: "Temporary storage location",
  },
  {
    value: 3,
    cnName: "贵重库位",
    enName: "Valuable storage space",
  },
];

const HandleType = [
  //数据处理类型
  {
    value: 1,
    cnName: "运算",
    enName: "operation",
  },
  {
    value: 2,
    cnName: "单元格标记",
    enName: "Cell tag",
  },
  {
    value: 3,
    cnName: "整行标记",
    enName: "Full line mark",
  },
  {
    value: 4,
    cnName: "文字标记",
    enName: "Literal marker",
  },
  {
    value: 5,
    cnName: "筛选",
    enName: "filtrate",
  },
  {
    value: 6,
    cnName: "去重后求和",
    enName: "Sum after removing weight",
  },
  {
    value: 7,
    cnName: "求和",
    enName: "summation",
  },
  {
    value: 8,
    cnName: "添加指定字段",
    enName: "Add specified field",
  },
  {
    value: 9,
    cnName: "计数",
    enName: "count",
  },
  {
    value: 10,
    cnName: "添加店铺名",
    enName: "Add store name",
  },
  {
    value: 11,
    cnName: "添加月份",
    enName: "Add month",
  },
  {
    value: 9998,
    cnName: "多表运算",
    enName: "Multitable formula",
  },
  {
    value: 99,
    cnName: "跳过表头行数",
    enName: "Skip the number of header rows",
  },
  {
    value: 9993,
    cnName: "多表添加字段",
    enName: "Add fields to multiple tables",
  },
  {
    value: 9994,
    cnName: "多表筛选",
    enName: "Multitable filtering",
  },
  {
    value: 9995,
    cnName: "多表标记文字",
    enName: "Multitable Marker text",
  },
  {
    value: 9996,
    cnName: "多表标记单元格",
    enName: "Multitable Tagged cell",
  },
  {
    value: 9997,
    cnName: "多表标记整行",
    enName: "Multitable Mark the whole line",
  },
  {
    value: 9999,
    cnName: "多表连表",
    enName: "Multitable operation",
  },
];

const ManulInventoryStatus = [
  //手工出入库单
  {
    value: 0,
    cnName: "待审核",
    enName: "To be reviewed",
    langLabel: "To_be_reviewed",
  },
  {
    value: 1,
    cnName: "审核通过",
    enName: "Approved",
    langLabel: "pass_the_audit",
  },
  {
    value: 4,
    cnName: "完成",
    enName: "finish",
    langLabel: "finish",
  },
  {
    value: 2,
    cnName: "驳回",
    enName: "Rejected",
    langLabel: "Reject",
  },
  {
    value: 3,
    cnName: "异常",
    enName: "Abnormal",
    langLabel: "Exception",
  },
];

const ManulInventoryType = [
  {
    value: 1,
    cnName: "出库",
    enName: "Outbound",
    langLabel: "Outbound",
  },
  {
    value: 0,
    cnName: "入库",
    enName: "Inbound",
    langLabel: "entering_the_warehouse",
  },
];

const WMSOerderType = [
  //待发货WMS订单状态
  {
    //未生成任务
    cnName: "未生成任务",
    enName: "Ungenerated task",
    class: "OrderStateInfo",
    value: "1",
  },
  {
    //待配货
    cnName: "待配货",
    enName: "To be allocated",
    class: "OrderStatePrimary",
    value: "2",
  },
  {
    //配货中
    cnName: "配货中",
    enName: "Being distributed",
    class: "OrderStatePrimary",
    value: "3",
  },
  {
    //已完成配货
    cnName: "已完成配货",
    enName: "distribution has been completed",
    class: "OrderStatePrimary",
    value: "4",
  },
  {
    //待分拣
    cnName: "待分拣",
    enName: "Waiting to be sorted",
    class: "OrderStatePrimary",
    value: "5",
  },
  {
    //分拣中
    cnName: "分拣中",
    enName: "In sorting",
    class: "OrderStatePrimary",
    value: "6",
  },
  {
    //已完成分拣
    cnName: "已完成分拣",
    enName: "Sorting has been completed",
    class: "OrderStatePrimary",
    value: "7",
  },
  {
    //发货中
    cnName: "发货中",
    enName: "On delivery",
    class: "OrderStatePrimary",
    value: "8",
  },
  {
    //配货异常
    cnName: "配货异常",
    enName: "Abnormal distribution",
    class: "OrderStateDanger",
    value: "10",
  },
  {
    //分拣异常
    cnName: "分拣异常",
    enName: "Sorting anomaly",
    class: "OrderStateDanger",
    value: "11",
  },
  {
    //发货异常
    cnName: "发货异常",
    enName: "Abnormal delivery",
    class: "OrderStateDanger",
    value: "12",
  },
  {
    //撤销异常
    cnName: "撤销异常",
    enName: "Undo exception",
    class: "OrderStateDanger",
    value: "13",
  },
  {
    //取消异常
    cnName: "取消异常",
    enName: "Cancel exceptions",
    class: "OrderStateDanger",
    value: "14",
  },
];

const SuccessWMSOerderType = [
  //完成WMS订单状态
  {
    //未生成任务
    cnName: "未生成任务",
    enName: "Ungenerated task",
    class: "OrderStateInfo",
    value: "1",
    langLabel: "Ungenerated_task",
  },
  {
    //待配货
    cnName: "待配货",
    enName: "To be allocated",
    class: "OrderStatePrimary",
    value: "2",
    langLabel: "To_be_distributed",
  },
  {
    //配货中
    cnName: "配货中",
    enName: "Being distributed",
    class: "OrderStatePrimary",
    value: "3",
    langLabel: "Being_distributed",
  },
  {
    //已完成配货
    cnName: "已完成配货",
    enName: "distribution has been completed",
    class: "OrderStatePrimary",
    value: "4",
    langLabel: "completed_distribution",
  },
  {
    //待分拣
    cnName: "待分拣",
    enName: "Waiting to be sorted",
    class: "OrderStatePrimary",
    value: "5",
    langLabel: "Pending_Sorting",
  },
  {
    //分拣中
    cnName: "分拣中",
    enName: "In sorting",
    class: "OrderStatePrimary",
    value: "6",
    langLabel: "Sorting_In_Progress",
  },
  {
    //已完成分拣
    cnName: "已完成分拣",
    enName: "Sorting has been completed",
    class: "OrderStatePrimary",
    value: "7",
    langLabel: "Sorting_Completed",
  },
  {
    //发货中
    cnName: "发货中",
    enName: "On delivery",
    class: "OrderStatePrimary",
    value: "8",
    langLabel: "In_transit",
  },
  {
    //已发货
    cnName: "已发货",
    enName: "Completed delivery",
    class: "OrderStateSuccess",
    value: "9",
    langLabel: "shipped",
  },
  {
    //配货异常
    cnName: "配货异常",
    enName: "Abnormal distribution",
    class: "OrderStateDanger",
    value: "10",
    langLabel: "Irregularity_in_delivery",
  },
  {
    //分拣异常
    cnName: "分拣异常",
    enName: "Sorting anomaly",
    class: "OrderStateDanger",
    value: "11",
    langLabel: "Sorting_Exception",
  },
  {
    //发货异常
    cnName: "发货异常",
    enName: "Abnormal delivery",
    class: "OrderStateDanger",
    value: "12",
    langLabel: "abnormal_delivery",
  },
  {
    //撤销异常
    cnName: "撤销异常",
    enName: "Undo exception",
    class: "OrderStateDanger",
    value: "13",
    langLabel: "Cancellation_Exception",
  },
  {
    //取消异常
    cnName: "取消异常",
    enName: "Cancel exceptions",
    class: "OrderStateDanger",
    value: "14",
    langLabel: "Void_Exception",
  },
];

const CostType = [
  //费用类型
  {
    value: 2,
    cnName: "费用补扣",
    enName: "Cost supplement",
  },
  {
    value: 3,
    cnName: "充值",
    enName: "Recharge",
  },
  {
    value: 4,
    cnName: "订单处理费",
    enName: "Order processing fee",
  },
  {
    value: 5,
    cnName: "仓租",
    enName: "Warehousing rent",
  },
  {
    value: 6,
    cnName: "上架费",
    enName: "Shelf fee",
  },
  {
    value: 11,
    cnName: "贴标费",
    enName: "Labeling fee",
  },
  {
    value: 12,
    cnName: "头程费用",
    enName: "Initial transportation cost",
  },
  {
    value: 13,
    cnName: "退件重新上架费",
    enName: "Return re-shelving fee",
  },
  {
    value: 14,
    cnName: "手工入库费",
    enName: "Manual storage fee",
  },
  {
    value: 15,
    cnName: "手工出库费",
    enName: "Manual outbound fee",
  },
  {
    value: 16,
    cnName: "废弃费",
    enName: "Disposal fee",
  },
  {
    value: 17,
    cnName: "撤销费用补扣",
    enName: "Cancellation fee deduction",
  },
];

const TypeStorage = [
  //出入库类型
  {
    value: 0,
    cnName: "入库单",
    enName: "Inbound",
    langLabel: "InventoryOrder",
  },
  {
    value: 1,
    cnName: "订单",
    enName: "Order",
    langLabel: "Order",
  },
  {
    value: 2,
    cnName: "移仓",
    enName: "Transfer",
    langLabel: "positionTransfer",
  },
  {
    value: 3,
    cnName: "手工出库单",
    enName: "Manual Outbound",
    langLabel: "Manual_Outbound_Order",
  },
  {
    value: 4,
    cnName: "手工入库单",
    enName: "Manual Inbound",
    langLabel: "Manual_Inbound_Order",
  },
  {
    value: 5,
    cnName: "移库",
    enName: "Move",
    langLabel: "shiftingParkingData",
  },
  {
    value: 6,
    cnName: "退件单",
    enName: "Return",
    langLabel: "return_order",
  },
  {
    value: 7,
    cnName: "调拨出库单",
    enName: "Transfer Outbound",
    langLabel: "Transfer_Outbound_Order",
  },
  {
    value: 8,
    cnName: "调拨入库单",
    enName: "Transfer Inbound",
    langLabel: "Transfer_Inbound_Order",
  },
  {
    value: 9,
    cnName: "盘点盘亏",
    enName: "Inventory loss",
    langLabel: "Inventory_Count_Loss",
  },
  {
    value: 10,
    cnName: "盘点盘盈",
    enName: "Inventory surplus",
    langLabel: "Inventory_Count_Surplus",
  },
  {
    value: 12,
    cnName: "退货库存移库上架",
    enName: "Return inventory transfer and shelving",
    langLabel: "Return_Stock_Move_To_Shelf",
  },
  {
    value: 11,
    cnName: "退货库位退回待审核状态",
    enName: "The returned location is returned to the pending review status",
    langLabel: "Return_Location_Return_To_Pending_Review_Status",
  },
  {
    value: 13,
    cnName: "隔离库位下架",
    enName: "The quarantine location is taken off the shelf",
    langLabel: "isolated_storage_location_down",
  },
  // {
  //   value: 14,
  //   cnName: "转入不可用库存",
  //   enName: "Transfer to unavailable inventory",
  //   langLabel: "Transfer_To_Unavailable_Inventory",
  // },
  // {
  //   value: 15,
  //   cnName: "转入可用库存",
  //   enName: "Transfer to available inventory",
  //   langLabel: "Transfer_To_Available_Inventory",
  // },
  {
    value: 14,
    cnName: "不可用库存移库",
    enName: "Transfer to unavailable inventory",
    langLabel: "Inventory_Transfer_To_Unavailable_Inventory",
  },
  {
    value: 15,
    cnName: "可用库存移库",
    enName: "Transfer to available inventory",
    langLabel: "Available_Inventory_Transfer",
  },
  {
    value: 16,
    cnName: "不可用库存上架",
    enName: "Inventory is not available",
    langLabel: "Unavailable_Inventory_Shelving",
  },
  {
    value: 17,
    cnName: "补货下架",
    enName: "Restocked and removed from shelves",
    langLabel: "Replenishment_Picking",
  },
  {
    value: 18,
    cnName: "补货下架分割下架",
    enName: "Replenishment removal from shelves split removal from shelves",
    langLabel: "Replenishment_Picking_Split_Picking",
  },
  {
    value: 19,
    cnName: "补货下架分割上架",
    enName: "Replenish remove from shelves split and put back on shelves",
    langLabel: "Replenishment_Picking_Split_Shelving",
  },
  {
    value: 20,
    cnName: "补货上架",
    enName: "Replenish inventory and put on shelves",
    langLabel: "Replenishment_Shelving",
  },
  {
    value: 21,
    cnName: "不可用库存下架",
    enName: "Inventory cannot be removed from the shelves",
    langLabel: "Inventory_cannot_be_removed_from_the_shelves",
  },
  {
    value: 23,
    cnName: "移仓迁出",
    enName: "Transfer out of warehouse",
    langLabel: "Transfer_out_of_warehouse",
  },
];

const TypeStorage2 = [
  //出入库类型
  {
    value: 0,
    cnName: "入库单",
    enName: "Inbound",
    langLabel: "InventoryOrder",
  },
  {
    value: 1,
    cnName: "订单",
    enName: "Order",
    langLabel: "Order",
  },
  {
    value: 2,
    cnName: "移仓",
    enName: "Transfer",
    langLabel: "positionTransfer",
  },
  {
    value: 3,
    cnName: "手工出库单",
    enName: "Manual Outbound",
    langLabel: "Manual_Outbound_Order",
  },
  {
    value: 4,
    cnName: "手工入库单",
    enName: "Manual Inbound",
    langLabel: "Manual_Inbound_Order",
  },
  {
    value: 5,
    cnName: "移库",
    enName: "Move",
    langLabel: "shiftingParkingData",
  },
  {
    value: 6,
    cnName: "退件单",
    enName: "Return",
    langLabel: "return_order",
  },
  {
    value: 7,
    cnName: "调拨出库单",
    enName: "Transfer Outbound",
    langLabel: "Transfer_Outbound_Order",
  },
  {
    value: 8,
    cnName: "调拨入库单",
    enName: "Transfer Inbound",
    langLabel: "Transfer_Inbound_Order",
  },
  {
    value: 9,
    cnName: "盘点盘亏",
    enName: "Inventory loss",
    langLabel: "Inventory_Count_Loss",
  },
  {
    value: 10,
    cnName: "盘点盘盈",
    enName: "Inventory surplus",
    langLabel: "Inventory_Count_Surplus",
  },
  {
    value: 12,
    cnName: "退货库存移库上架",
    enName: "Return inventory transfer and shelving",
    langLabel: "Return_Stock_Move_To_Shelf",
  },
  {
    value: 11,
    cnName: "退货库位退回待审核状态",
    enName: "The returned location is returned to the pending review status",
    langLabel: "Return_Location_Return_To_Pending_Review_Status",
  },
  {
    value: 13,
    cnName: "隔离库位下架",
    enName: "The quarantine location is taken off the shelf",
    langLabel: "isolated_storage_location_down",
  },
  {
    value: 14,
    cnName: "不可用库存移库",
    enName: "Transfer to unavailable inventory",
    langLabel: "Inventory_Transfer_To_Unavailable_Inventory",
  },
  {
    value: 15,
    cnName: "可用库存移库",
    enName: "Transfer to available inventory",
    langLabel: "Available_Inventory_Transfer",
  },
  {
    value: 16,
    cnName: "不可用库存上架",
    enName: "Inventory is not available",
    langLabel: "Unavailable_Inventory_Shelving",
  },
  {
    value: 17,
    cnName: "补货下架",
    enName: "Restocked and removed from shelves",
    langLabel: "Replenishment_Picking",
  },
  {
    value: 18,
    cnName: "补货下架分割下架",
    enName: "Replenishment removal from shelves split removal from shelves",
    langLabel: "Replenishment_Picking_Split_Picking",
  },
  {
    value: 19,
    cnName: "补货下架分割上架",
    enName: "Replenish remove from shelves split and put back on shelves",
    langLabel: "Replenishment_Picking_Split_Shelving",
  },
  {
    value: 20,
    cnName: "补货上架",
    enName: "Replenish inventory and put on shelves",
    langLabel: "Replenishment_Shelving",
  },
  {
    value: 21,
    cnName: "不可用库存下架",
    enName: "Inventory cannot be removed from the shelves",
    langLabel: "Inventory_cannot_be_removed_from_the_shelves",
  },
  {
    value: 23,
    cnName: "移仓迁出",
    enName: "Transfer out of warehouse",
    langLabel: "Transfer_out_of_warehouse",
  },
];  

const BillingType = [
  //固定SKU费用类型
  {
    value: 0,
    cnName: "普通",
    enName: "common",
  },
  {
    value: 1,
    cnName: "首重",
    enName: "First weight",
  },
  {
    value: 2,
    cnName: "续重",
    enName: "Additional Weight",
  },
  {
    value: 3,
    cnName: "下架附加费",
    enName: "Off-shelf Surcharge",
  },
  {
    value: 4,
    cnName: "额外包材费",
    enName: "Additional Packaging Fee",
  },
  {
    value: 5,
    cnName: "固定首件",
    enName: "Fixed first piece",
  },
  {
    value: 6,
    cnName: "固定续件",
    enName: "Fixed continuation",
  },
];

const PickingStage = [
  //配货阶段
  {
    value: 0,
    cnName: "待配货",
    enName: "To be allocated",
    langLabel: "To_be_distributed",
  },
  {
    value: 1,
    cnName: "配货中",
    enName: "Being distributed",
    langLabel: "Being_distributed",
  },
  {
    value: 2,
    cnName: "配货完成",
    enName: "Allocation completed",
    langLabel: "Allocation_completed",
  },
];

const SortingStage = [
  //分拣阶段
  {
    value: 1,
    cnName: "未完全扫描配货篮子",
    enName: "The distribution basket has not been scanned",
    langLabel: "The_distribution_basket_has_not_been_scanned",
  },
  {
    value: 2,
    cnName: "未开始分拣",
    enName: "Sorting has not begun",
    langLabel: "Sorting_has_not_begun",
  },
  {
    value: 3,
    cnName: "分拣中",
    enName: "Sorting",
    langLabel: "Sorting",
  },
  {
    value: 4,
    cnName: "分拣完成",
    enName: "Sorting completed",
    langLabel: "Sorting_completed",
  },
];

const ShippingStage = [
  //发货阶段
  {
    value: 0,
    cnName: "未发货",
    enName: "not yet shipped",
    langLabel: "Not_yet_shipped",
  },
  {
    value: 1,
    cnName: "发货中",
    enName: "On delivery",
    langLabel: "In_transit",
  },
  {
    value: 2,
    cnName: "发货完成",
    enName: "Delivery completed",
    langLabel: "Delivery_completed",
  },
];

const RecommendStockUnitType = [
  {
    value: 0,
    cnName: "库存占用库位",
    enName: "Last used library location",
  },
  {
    value: 1,
    cnName: "相邻库位",
    enName: "Adjacent storage location",
  },
];

const TaskType = [
  //任务类型
  {
    value: 0,
    cnName: "单品",
    enName: "item",
    langLabel: "Item",
  },
  {
    value: 1,
    cnName: "多品",
    enName: "multi-class",
    langLabel: "Multi_class",
  },
  {
    value: 2,
    cnName: "边配边分",
    enName: "Match and divide",
    langLabel: "Match_and_divide",
  },
  {
    value: 3,
    cnName: "爆款发货",
    enName: "Explosive delivery",
    langLabel: "Explosive_delivery",
  },
  {
    value: 4,
    cnName: "贴单出库",
    enName: "Sticking order Out of stock",
    langLabel: "Sticking_order_Out_of_stock",
  },
  {
    value: 5,
    cnName: "一键出库",
    enName: "One click out of storage",
    langLabel: "One_click_out_of_storage",
  },
];

const OrderType = [
  //订单类型
  {
    value: 0,
    cnName: "单品",
    enName: "item",
    langLabel: "Item",
  },
  {
    value: 1,
    cnName: "多品",
    enName: "multi-class",
    langLabel: "Multi_class",
  },
  {
    value: 2,
    cnName: "单品多量",
    enName: "Single product quantity",
    langLabel: "Single_product_quantity",
  },
  {
    value: 3,
    cnName: "合单",
    enName: "Joining orders",
    langLabel: "Joining_orders",
  },
  {
    value: 4,
    cnName: "贴单出库",
    enName: "Sticking order Out of stock",
    langLabel: "Sticking_order_Out_of_stock",
  },
];

const WMSOrderLogType = [
  //WMS订单日志类型
  {
    value: 0,
    cnName: "配货",
    enName: "distribution",
    langLabel: "Picking",
  },
  {
    value: 1,
    cnName: "分拣",
    enName: "sorting",
    langLabel: "Sorting",
  },
  {
    value: 2,
    cnName: "发货",
    enName: "deliver goods",
    langLabel: "Shipping",
  },
  {
    value: 3,
    cnName: "配货异常",
    enName: "Distribution anomaly",
    langLabel: "Irregularity_in_delivery",
  },
  {
    value: 4,
    cnName: "分拣异常",
    enName: "Sorting anomaly",
    langLabel: "Sorting_Exception",
  },
  {
    value: 5,
    cnName: "发货异常",
    enName: "Delivery exception",
    langLabel: "Shipment_exception",
  },
  {
    value: 6,
    cnName: "取消异常",
    enName: "Cancel exception",
    langLabel: "Cancellation_Exception",
  },
  {
    value: 7,
    cnName: "撤销异常",
    enName: "Undo exception",
    langLabel: "Revocation_Exception",
  },
  {
    value: 8,
    cnName: "取消订单",
    enName: "cancellation of order",
    langLabel: "cancellation_of_order",
  },
  {
    value: 9,
    cnName: "一键出库",
    enName: "One click out of storage",
    langLabel: "One_click_out_of_storage",
  },
];

const DeliveryProcess = [
  //发货流程
  {
    value: 0,
    cnName: "发货流程1",
    enName: "delivery process one",
  },
  {
    value: 1,
    cnName: "发货流程2",
    enName: "delivery process two",
  },
];

const ExportTaskData = [
  //导出类型
  {
    //导出账单明细
    value: "DeriveBillDetail",
    cnName: "导出账单明细",
    enName: "Export bill",
  },
  {
    //导出头程订单与账单
    value: "DeriveFirstLegOrder",
    cnName: "导出头程订单与账单",
    enName: "Export first leg order",
  },
  {
    //导出商品列表 (分仓库)
    value: "DeriveProductDetailList",
    cnName: "导出商品列表 (分仓库)",
    enName: "Export product list (warehouse)",
  },
  {
    //导出商品列表
    value: "DeriveProductList",
    cnName: "导出商品列表",
    enName: "Export product list",
  },
  {
    //导出库存列表
    value: "DeriveInventoryList",
    cnName: "导出库存列表",
    enName: "Export inventory list",
  },
  {
    //导出出入库记录
    value: "DeriveEntryAndExitRecordsDetailsList",
    cnName: "导出出入库记录",
    enName: "Export entry and exit records",
  },
  {
    //导出入库单
    value: "DeriveProductEntries",
    cnName: "导出入库单",
    enName: "Export product entries",
  },
  {
    //导出订单
    value: "DeriveOrderList",
    cnName: "导出订单",
    enName: "Export order",
  },
  {
    //导出仓租账单
    value: "DeriveStockRentalFeeBillList",
    cnName: "导出仓租账单",
    enName: "Export stock rental bill",
  },
  {
    //导出销量
    value: "SalesVolumeDetailList",
    cnName: "导出销量",
    enName: "Export sales volume",
  },
  {
    //导出日销量
    value: "SalesVolumeDetailDateList",
    cnName: "导出日销量",
    enName: "Export daily sales volume",
  },
  {
    //导出仓租账单明细
    value: "DeriveStockRentalFeeBillItemList",
    cnName: "导出仓租账单明细",
    enName: "Export stock rental bill details",
  },
  {
    //导出退货列表(管理端)
    value: "GetSignReturnOrderExportList",
    cnName: "导出退货列表(管理端)",
    enName: "Export return order list (management side)",
  },
  {
    //导出充值记录
    value: "RechargeTransactionsExportList",
    cnName: "导出充值记录",
    enName: "RechargeTransactionsExportList",
  },
  {
    //导出费用补扣列表
    value: "ExportdDeductFeeList",
    cnName: "导出费用补扣列表",
    enName: "ExportdDeductFeeList",
  },
];

const SkuStorageType = [
  //SKU存放类型
  {
    //单SKU
    value: 0,
    cnName: "单SKU",
    enName: "Single_SKU",
  },
  {
    //多SKU
    value: 1,
    cnName: "多SKU",
    enName: "Multiple_SKU",
  },
];

const OrderSource = [
  //订单来源
  {
    value: 1,
    cnName: "API订单",
    enName: "Api Order",
    langLabel: "Api_Order",
  },
  {
    value: 2,
    cnName: "推送单",
    enName: "Notification form",
    langLabel: "Notification_Form",
  },
  {
    value: 3,
    cnName: "手工单",
    enName: "handbill",
    langLabel: "handbill",
  },
];

const TaskGenerationType = [
  //任务生成类型
  {
    value: 0,
    cnName: "按单生成",
    enName: "Build to order",
    langLabel: "Generate_By_Order",
  },
  {
    value: 1,
    cnName: "按箱生成",
    enName: "Box generation",
    langLabel: "Generate_By_Carton",
  },
  {
    value: 2,
    cnName: "边质检边上架",
    enName: "Quality inspection side frame",
    langLabel: "Quality_Inspect_And_Shelve_Concurrently",
  },
];
const automaticReturnDatas = [
  {
    cnName: "仅登记",
    enName: "only registration",
    value: 0,
    langLabel: "Only_registration",
  },
  {
    cnName: "上架至退货库位",
    enName: "shelf return warehouse location",
    value: 1,
    langLabel: "shelf_return_warehouse_location",
  },
  {
    cnName: "登记并上架",
    enName: "register list",
    value: 2,
    langLabel: "registerList",
  },
];
//处理方案数据
const Treatment = [
  {
    value: 0,
    cnName: "上架",
    enName: "putaway",
  },
  {
    value: 1,
    cnName: "废弃",
    enName: "Abandon",
  },
];
// 退货库存列表表头
const printThead = [
  {
    cnName: "SKU",
    enName: "SKU",
  },
  {
    cnName: "商品条码",
    enName: "bar code",
  },
  {
    cnName: "上架数量",
    enName: "Number of listings",
  },
  {
    cnName: "退货库位",
    enName: "Return warehouse location",
  },
  {
    cnName: "上架库位",
    enName: "Shelf location",
  },
  {
    cnName: "上架时间",
    enName: "Listing time",
  },
  {
    cnName: "上架人",
    enName: "Listing person",
  },
];
//移库任务下架流水 表头
const transferTaskPrintThead = [
  {
    cnName: "订单号",
    enName: "Order No",
  },
  {
    cnName: "sku",
    enName: "sku",
  },
  {
    cnName: "商品条码",
    enName: "bar code",
  },
  {
    cnName: "当前批次总库存",
    enName: "Total inventory of current batch",
  },
  {
    cnName: "库位总库存",
    enName: "Total inventory of storage locations",
  },
  {
    cnName: "库存变动数量",
    enName: "Inventory change quantity",
  },
  {
    cnName: "备注",
    enName: "notes",
  },
  {
    cnName: "创建时间",
    enName: "createTime",
  },
  {
    cnName: "审核人",
    enName: "reviewer",
  },
  {
    cnName: "审核时间",
    enName: "Audit time",
  },
  {
    cnName: "上架人",
    enName: "Listing person",
  },
  {
    cnName: "上架时间",
    enName: "Listing time",
  },
  {
    cnName: "收货人",
    enName: "consignee",
  },
  {
    cnName: "收货时间",
    enName: "Delivery time",
  },
];

//报表时间筛选
const selectReportTime = [
  {
    cnName: "下单时间",
    enName: "createTime",
  },
  {
    cnName: "出库时间",
    enName: "deliveryTime",
  },
  {
    cnName: "更新时间",
    enName: "lastUpdateTime",
  },
  {
    cnName: "完成时间",
    enName: "completeTime",
  },
  {
    cnName: "结算时间",
    enName: "settleAccountsTime",
  },
];

//待发货异常WMS订单状态

const WMSAbnormalOrderStatus = [
  {
    //配货异常
    cnName: "配货异常",
    enName: "Abnormal distribution",
    class: "OrderStateDanger",
    value: "10",
  },
  {
    //分拣异常
    cnName: "分拣异常",
    enName: "Sorting anomaly",
    class: "OrderStateDanger",
    value: "11",
  },
  {
    //发货异常
    cnName: "发货异常",
    enName: "Abnormal delivery",
    class: "OrderStateDanger",
    value: "12",
  },
  {
    //撤销异常
    cnName: "撤销异常",
    enName: "Undo exception",
    class: "OrderStateDanger",
    value: "13",
  },
];
// 下发状态选项
const dispatchStatusOptions = [
  {
    value: "0",
    cnName: "未下发",
    enName: "Not issued",
    class: "OrderStateInfo",
  },
  {
    value: "1",
    cnName: "已下发",
    enName: "Issued",
    class: "OrderStateSuccess",
  },
  {
    value: "2",
    cnName: "截单中",
    enName: "Order Closing",
    class: "OrderStateWarning",
  },
  {
    value: "3",
    cnName: "截单失败",
    enName: "Order submission failed",
    class: "OrderStateDanger",
  },
];
// 发运类型选项
const shipmentTypeOptions = [
  {
    value: 1,
    cnName: "上门",
    enName: "Pickup_at_location",
    label: "Pickup_at_location",
  },
  {
    value: 2,
    cnName: "快递",
    enName: "Delivery_service",
    label: "Delivery_service",
  },
  {
    value: 3,
    cnName: "卡派",
    enName: "Truk_delivery",
    label: "Truk_delivery",
  },
];
// const shipmentTypeOptions = [
//   {
//     value: 1,
//     cnName: "上门自提",
//     enName: "Pickup_at_location",
//     label: "Pickup_at_location",
//   },
//   {
//     value: 2,
//     cnName: "代叫配送",
//     enName: "Delivery_service",
//     label: "Delivery_service",
//   },
//   // {
//   //   value: 3,
//   //   cnName: "卡派",
//   //   enName: "Truk_delivery",
//   //   label: "Truk_delivery",
//   // },
// ];
// 迁出阶段选项
const transferOutStage = [
  {
    value: 0,
    cnName: "待确认",
    enName: "To_be_confirmed",
  },
  {
    value: 1,
    cnName: "待审核",
    enName: "To_be_reviewed",
  },
  {
    value: 2,
    cnName: "待下架",
    enName: "To_be_offlined",
  },
  {
    value: 3,
    cnName: "下架中",
    enName: "Being_offlined",
  },
  {
    value: 4,
    cnName: "处理中",
    enName: "processing",
  },
  {
    value: 5,
    cnName: "待发运",
    enName: "To_be_transfered",
  },
  {
    value: 6,
    cnName: "已完成",
    enName: "completed",
  },
  {
    value: 7,
    cnName: "已作废",
    enName: "have_been_voided",
  },
  {
    value: 8,
    cnName: "已驳回",
    enName: "have_been_reject",
  },
];

const FILE_TYPE_LIST = [
  {
    extension: "jpg",
    mimeType: "image/jpeg",
  },
  {
    extension: "png",
    mimeType: "image/png",
  },
  {
    extension: "mp4",
    mimeType: "video/mp4",
  },
  {
    extension: "mov",
    mimeType: "video/quicktime",
  },
  {
    extension: "wmv",
    mimeType: "video/x-ms-wmv",
  },
  {
    extension: "docx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  {
    extension: "doc",
    mimeType: "application/msword",
  },
  {
    extension: "xlsx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  {
    extension: "xls",
    mimeType: "application/vnd.ms-excel",
  },
  {
    extension: "csv",
    mimeType: "text/csv",
  },
  {
    extension: "zip",
    mimeType: "application/x-zip-compressed",
  },
  {
    extension: "rar",
    mimeType: "application/vnd.rar",
  },
  {
    extension: "7z",
    mimeType: "application/x-7z-compressed",
  },
];

//充值申请状态
const rechargeApplicationStatus = [
  {
    value: 0,
    langLabel: "draft", //草稿
  },
  {
    value: 1,
    langLabel: "To_be_reviewed", //待审核
  },
  {
    value: 2,
    langLabel: "pass_the_audit", //审核通过
  },
  {
    value: 3,
    langLabel: "Reject", //驳回
  },
  {
    value: 4,
    langLabel: "cancellation", //作废
  },
];

//充值申请状态-管理端
const rechargeApplicationStatusManagement = [
  {
    value: 1,
    langLabel: "To_be_reviewed", //待审核
  },
  {
    value: 2,
    langLabel: "pass_the_audit", //审核通过
  },
  {
    value: 3,
    langLabel: "Reject", //驳回
  },
];

const positionTransferOccupation = [
  {
    value: 0,
    cnName: "全部",
    enName: "All",
  },
  {
    value: 1,
    cnName: "待移仓",
    enName: "Pending Transfer",
  },
  {
    value: 2,
    cnName: "待审核",
    enName: "Pending Approval",
  },
  {
    value: 3,
    cnName: "待接收",
    enName: "Pending Receipt",
  },
  {
    value: 4,
    cnName: "已移仓",
    enName: "Transferred",
  },
  {
    value: 5,
    cnName: "已撤销",
    enName: "Cancelled",
  },
];

const TransferOutPosition = [
  {
    value: -1,
    cnName: "全部",
    enName: "All",
  },
  {
    value: 0,
    cnName: "待确认",
    enName: "Pending Confirmation",
  },
  {
    value: 1,
    cnName: "待审核",
    enName: "Pending Approval",
  },
  {
    value: 2,
    cnName: "待下架",
    enName: "Pending Offline",
  },
  {
    value: 3,
    cnName: "下架中",
    enName: "Being Offlined",
  },
  {
    value: 4,
    cnName: "处理中",
    enName: "Processing",
  },
  {
    value: 5,
    cnName: "待发运",
    enName: "Pending Shipment",
  },
  {
    value: 6,
    cnName: "已完成",
    enName: "Completed",
  },
  {
    value: 7,
    cnName: "已作废",
    enName: "Cancelled",
  },
  {
    value: 8,
    cnName: "已驳回",
    enName: "Rejected",
  },
];

// 隔离库位日志
const IsolatedStorageLogType = [
  {
    value: 5,
    cnName: "隔离库位上架",
    langLabel: "isolated_storage_location_up",
  },
  {
    value: 13,
    cnName: "隔离库位下架",
    langLabel: "isolated_storage_location_down",
  },
];

export {
  AnnouncementType,
  Platform,
  addTemuPlatform,
  LogisticsStatus,
  OrderStatus,
  FirstLegOrderStatus,
  OrderDisposeStatus,
  OrderTypes,
  DeliveryType,
  ChannelType,
  InitiateMode,
  AlarmThresholdStatus,
  PortType,
  BillingMethod,
  FirstVesselBillingMethod,
  ManagementFirstLegOrderStatus,
  CancellationOrderStatus,
  ReturnPhase,
  ManulInventoryType,
  ReturnOrderTypes,
  FirstBillingStage,
  ManagementFirstBillingStage,
  StatusOfStorageReceipt,
  ManagementStatusOfStorageReceipt,
  StockUnitType,
  HandleType,
  PrecedenceBillingMethod,
  ManulInventoryStatus,
  ManagementSideOrderDisposeStatus,
  WMSOerderType,
  CostType,
  TypeStorage,
  TypeStorage2,
  BillingType,
  PickingStage,
  SortingStage,
  ShippingStage,
  RecommendStockUnitType,
  TaskType,
  SuccessWMSOerderType,
  WMSOrderLogType,
  DeliveryProcess,
  OrderType,
  ExportTaskData,
  SkuStorageType,
  OrderSource,
  TaskGenerationType,
  Treatment,
  printThead,
  transferTaskPrintThead,
  selectReportTime,
  WMSAbnormalOrderStatus,
  dispatchStatusOptions,
  automaticReturnDatas,
  Language,
  rechargeApplicationStatus,
  rechargeApplicationStatusManagement,
  shipmentTypeOptions,
  transferOutStage,
  FILE_TYPE_LIST,
  positionTransferOccupation,
  TransferOutPosition,
  IsolatedStorageLogType,
};
